import { useEffect, useState } from 'react';

export const CkEditorContent = ({ html }) => {
  const [processedHtml, setProcessedHtml] = useState('');

  useEffect(() => {
    const processOembedContent = (htmlString) => {
      // Create a temporary DOM element to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Find all oembed elements
      const oembeds = tempDiv.querySelectorAll('oembed');
      
      oembeds.forEach(oembed => {
        const url = oembed.getAttribute('url');
        if (url) {
          // Handle YouTube URLs
          if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const videoId = extractYouTubeId(url);
            if (videoId) {
              const iframe = createYouTubeIframe(videoId);
              
              // Replace the parent figure with our iframe
              const figure = oembed.closest('figure.media');
              if (figure) {
                figure.parentNode.replaceChild(iframe, figure);
              }
            }
          }
        }
      });

      return tempDiv.innerHTML;
    };

    setProcessedHtml(processOembedContent(html));
  }, [html]);

  // Helper function to extract YouTube video ID
  const extractYouTubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // Helper function to create YouTube iframe
  const createYouTubeIframe = (videoId) => {
    const styles = {
      container: {
        position: 'relative',
        width: '100%',
        paddingBottom: '56.25%', // 16:9 aspect ratio
        height: 0,
      },
      iframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0,
      }
    };

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');

    // Create a container div
    Object.assign(iframe.style, styles.iframe);
    const container = document.createElement('div');
    Object.assign(container.style, styles.container);
    container.appendChild(iframe);

    return container;
  };

  return (
    <div 
      className="ck-content" 
      dangerouslySetInnerHTML={{ __html: processedHtml }} 
    />
  );
};
